module.exports = global["jQuery"] = require("-!/home/travis/build/stasguryev/core-ui/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ../~/jquery/dist/jquery.js
// module id = 57
// module chunks = 0